import { isEmbedAnalyticsDisabled } from './embedAnalytics'
const EMAIL_ATTRIBUTION_QUERY_PARAM = 'cat'
const EMAIL_ATTRIBUTION_STORAGE_KEY = 'cassyni_email_attribution_token'

export const captureEmailAttributionFromUrl = () => {
  if (isEmbedAnalyticsDisabled) return
  if (typeof window === 'undefined') return

  const url = new URL(window.location.href)
  const token = url.searchParams.get(EMAIL_ATTRIBUTION_QUERY_PARAM)
  if (!token) return

  try {
    window.sessionStorage.setItem(EMAIL_ATTRIBUTION_STORAGE_KEY, token)
  } catch {
    return
  }

  url.searchParams.delete(EMAIL_ATTRIBUTION_QUERY_PARAM)
  window.history.replaceState(
    window.history.state,
    document.title,
    `${url.pathname}${url.search}${url.hash}`,
  )
}

export const getEmailAttributionToken = () => {
  if (isEmbedAnalyticsDisabled) return undefined
  if (typeof window === 'undefined') return undefined

  try {
    return window.sessionStorage.getItem(EMAIL_ATTRIBUTION_STORAGE_KEY) ?? undefined
  } catch {
    return undefined
  }
}

export const withEmailAttribution = <T extends Record<string, unknown>>(payload: T) => {
  const emailAttributionToken = getEmailAttributionToken()
  if (!emailAttributionToken) return payload

  return {
    ...payload,
    email_attribution_token: emailAttributionToken,
  }
}
